import React from 'react'

const ToolCard = ({ tool }) => {
  const categoryColors = {
    'NLP': 'from-blue-500 to-cyan-500',
    'Image Generation': 'from-purple-500 to-pink-500',
    'Code Generation': 'from-green-500 to-emerald-500',
    'Data Analysis': 'from-orange-500 to-red-500',
    'Video Generation': 'from-indigo-500 to-purple-500',
    '3D Generation': 'from-teal-500 to-blue-500',
    'Content Creation': 'from-yellow-500 to-orange-500',
    'Productivity': 'from-gray-500 to-slate-500',
    'Audio Processing': 'from-pink-500 to-rose-500',
    'Model Hosting': 'from-violet-500 to-purple-500',
    'Search': 'from-cyan-500 to-blue-500',
  }

  const getCategoryColor = (category) => {
    return categoryColors[category] || 'from-gray-500 to-gray-600'
  }

  return (
    <div className="glass-card rounded-2xl p-6 hover:scale-105 transition-all duration-300 group animate-float">
      {/* Category Badge */}
      <div className="flex items-center justify-between mb-4">
        <span className={`px-3 py-1 rounded-full text-xs font-semibold text-white bg-gradient-to-r ${getCategoryColor(tool.category)} shadow-lg`}>
          {tool.category}
        </span>
        <a
          href={tool.website}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-300 text-white/80 hover:text-white"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </a>
      </div>

      {/* Tool Name */}
      <h3 className="text-xl font-bold text-white mb-3 group-hover:text-blue-200 transition-colors">
        {tool.name}
      </h3>

      {/* Description */}
      <p className="text-white/80 text-sm mb-4 leading-relaxed">
        {tool.description}
      </p>

      {/* Features */}
      <div className="space-y-2">
        <h4 className="text-white/90 font-semibold text-sm">Key Features:</h4>
        <div className="flex flex-wrap gap-2">
          {tool.features.map((feature, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-white/10 text-white/80 text-xs rounded-lg border border-white/20"
            >
              {feature}
            </span>
          ))}
        </div>
      </div>

      {/* Hover Effect Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
    </div>
  )
}

export default ToolCard
